import React, { createContext, useContext } from "react";

const BackgroundQueryContext = createContext(null);

const BackgroundQueryProvider = ({ children, prefetchRegistryRef }) => {
  if (!prefetchRegistryRef?.current) {
    throw new Error(
      "BackgroundQueryProvider requires a ref with .current initialized to an object"
    );
  }

  return (
    <BackgroundQueryContext.Provider value={prefetchRegistryRef}>
      {children}
    </BackgroundQueryContext.Provider>
  );
};

const useBackgroundQueryContext = () => {
  const context = useContext(BackgroundQueryContext);
  if (context === null) {
    throw new Error(
      "You must use useBackgroundQueryContext within a BackgroundQueryProvider"
    );
  }
  return context.current;
};

export { BackgroundQueryProvider, useBackgroundQueryContext };
